import React from "react";
import { Box, Typography } from "@mui/material";
import AdxInput from "components/custom/AdxInput";

export const AllocationComponent = ({
  item,
  name,
  isSubRow = false,
  subLabel = null,
  disabled = true,
  balanceName,
  amountName,
  onChange,
  onBlur,
  balanceErrorMessage,
  amountErrorMessage,
  isBalanceErrorShown,
  isAmountErrorShown,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        pl: isSubRow ? 2 : 0,      // ✅ small indent for carry forward row
        opacity: isSubRow ? 0.9 : 1,
      }}
    >
      <Box sx={{ mt: isSubRow ? -1.5 : -2, width: 2 / 4 }}>
        <Typography variant="body1" color="dark-gray-text.main">
          {name}
        </Typography>

        {/* ✅ optional extra line (expiry date) */}
        {subLabel ? (
          <Typography variant="caption" color="light-gray-text.main">
            {subLabel}
          </Typography>
        ) : null}
      </Box>

      <Box sx={{ width: 1 / 4 }}>
        <AdxInput
          disabled={disabled}
          name={balanceName}
          onChange={onChange}
          onBlur={onBlur}
          sxLabel={{
            color: "dark-text.main",
            "& .MuiInputBase-root": {
              "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                "-webkit-appearance": "none",
              },
            },
          }}
          sxInput={{
            color: "light-gray-text.main",
            backgroundColor: "default-background.main",
          }}
          size="standard"
          type="number"
          value={item?.balance ?? 0}
          errorMessage={balanceErrorMessage}
          isErrorShown={isBalanceErrorShown}
          sx={{ width: { xs: "100%", sm: "60%" }, mb: 2.5 }}
        />
      </Box>

      <Box sx={{ width: 1 / 4 }}>
        <AdxInput
          disabled={disabled}
          name={amountName}
          onChange={onChange}
          onBlur={onBlur}
          sxLabel={{
            color: "dark-text.main",
          }}
          sxInput={{
            color: "light-gray-text.main",
            backgroundColor: "default-background.main",
          }}
          size="standard"
          type="number"
          value={item?.amount ?? 0}
          errorMessage={amountErrorMessage}
          isErrorShown={isAmountErrorShown}
          sx={{ width: { xs: "100%", sm: "60%" }, mb: 2.5 }}
        />
      </Box>
    </Box>
  );
};
